var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',{attrs:{"type":"stacked"}},[_c('template',{slot:"primary"},[_c('color-picker',{attrs:{"value":_vm.color},on:{"input":_vm.onInput}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }